<template>
  <a class="queryCard"
     rel="nofollow"
     :href="link ? link.url : '#'">
    <font-awesome-icon v-if="faIcon"
                       aria-hidden="true"
                       class="queryCard__icon"
                       :icon="faIcon">
    </font-awesome-icon>
    <div class="queryCard__content">
      <div class="queryCard__text">
        <h3 class="queryCard__title">
          {{ query }}
        </h3>
        <p class="queryCard__info">
          {{ info }}
        </p>
      </div>
      <template v-if="link && link.url">
        <gl-link :as-dummy="true"
                 :font-size="0.88">
          {{ label }}
        </gl-link>
      </template>
      <template v-else>
        <slot name="link"></slot>
      </template>
    </div>
  </a>
</template>
<script>
export default {
  name: "QueryCard",
  props: {
    faIcon: {
      type: Array,
      default: () => undefined,
    },
    query: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      default: undefined,
    },
    link: {
      type: Object,
      default: () => undefined,
      validator: val => {
        const schema = ["label", "url"];
        return schema.every( key => key in val );
      },
    },
  },
  computed: {
    label () {
      const { label } = this.link;
      return this.isNullOrEmpty( label ) ? "" : label.toUpperCase();
    },
  },
  methods: {
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../Styles/utils/index.less";
@whitesmoke: #f9f8f7;
@crimson: #d61921;

.queryCard {
  display: flex;
  padding: 32px;
  width: 50%;
  min-height: 216px;
  min-width: 360px;
  cursor: pointer;
  text-decoration: none;
  color: #000;

  @media (max-width: @lg) {
    width: 100%;
    padding: 16px;
  }

  &:hover {
    background-color: @whitesmoke;
    text-decoration: none;
  }

  &__title {
    color: #434343;
    font-size: 2rem;
  }

  &__icon {
    width: 36px;
    height: 36px;
  }

  &__content {
    padding: 0 0 0 16px;
    flex: 1 1 auto;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  &__text {
    display: flex;
    flex-flow: column;
  }

  &__info {
    flex: 1 1 auto;
    font-weight: 300;
    color: #666666;
  }

  &__link {
    justify-content: flex-start;
    display: flex;
    align-items: center;
    color: @crimson;
    font-size: 0.88rem;
  }
}
</style>
